import { FarmlyPlace } from "@/lib/types";

export const PLACES: FarmlyPlace[] = [
  {
    id: "1",
    slug: "stenshuvuds-gardsbutik",
    name: "Stenshuvuds Gårdsbutik",
    municipality: "Simrishamn",
    landskap: "Skåne",
    county: "Skåne län",
    tags: ["gårdsbutik", "grönt", "ägg"],
    description_short: "Ekologiska grönsaker och ägg i vackra Österlen.",
    address_text: "Stenshuvudsvägen 12, Kivik",
    website: "https://stenshuvudsgard.se",
    instagram: "stenshuvudsgard",
    verified_at: "2026-01-15",
    lat: 55.7219,
    lng: 14.2650,
  },
  {
    id: "2",
    slug: "rattviks-lamm",
    name: "Rättviks Lamm",
    municipality: "Rättvik",
    landskap: "Dalarna",
    county: "Dalarnas län",
    tags: ["kött", "gårdsbutik"],
    description_short: "Naturbeteskött från får som betar i Siljansbygden.",
    website: "https://rattvikslamm.se",
    verified_at: "2026-01-10",
    lat: 60.8856,
    lng: 15.1159,
  },
  {
    id: "3",
    slug: "olands-honung",
    name: "Ölands Honung",
    municipality: "Borgholm",
    landskap: "Öland",
    county: "Kalmar län",
    tags: ["honung", "gårdsbutik"],
    description_short: "Lokalt producerad honung från alvaret.",
    address_text: "Alvarvägen 5, Borgholm",
    phone: "070-123 45 67",
    verified_at: "2025-12-20",
    lat: 56.8796,
    lng: 16.6560,
  },
  {
    id: "4",
    slug: "faro-fisk",
    name: "Fårö Fisk",
    municipality: "Gotland",
    landskap: "Gotland",
    county: "Gotlands län",
    tags: ["fisk", "café"],
    description_short: "Nyrökta flundror och kaffe vid havet.",
    instagram: "farofisk",
    lat: 57.9565,
    lng: 19.1395,
  },
  {
    id: "5",
    slug: "varmlandsgarden",
    name: "Värmlandsgården",
    municipality: "Sunne",
    landskap: "Värmland",
    county: "Värmlands län",
    tags: ["mejeri", "gårdsbutik", "café"],
    description_short: "Ost och glass från egna kor i hjärtat av Värmland.",
    website: "https://varmlandsgarden.se",
    instagram: "varmlandsgarden",
    verified_at: "2026-01-05",
    lat: 59.8375,
    lng: 13.1393,
  },
  {
    id: "6",
    slug: "hallands-sjalvplock",
    name: "Hallands Självplock",
    municipality: "Falkenberg",
    landskap: "Halland",
    county: "Hallands län",
    tags: ["självplock", "grönt"],
    description_short: "Plocka dina egna jordgubbar och bär i sommar.",
    address_text: "Jordgubbsvägen 8, Falkenberg",
    website: "https://hallandssjalvplock.se",
    lat: 56.9055,
    lng: 12.4912,
  },
  {
    id: "7",
    slug: "upplands-agg",
    name: "Upplands Ägg",
    municipality: "Uppsala",
    landskap: "Uppland",
    county: "Uppsala län",
    tags: ["ägg", "gårdsbutik"],
    description_short: "Frigående höns och riktigt gula äggulor.",
    phone: "018-12 34 56",
    verified_at: "2025-11-30",
    lat: 59.8586,
    lng: 17.6389,
  },
  {
    id: "8",
    slug: "smalands-kotteri",
    name: "Smålands Kötteri",
    municipality: "Vetlanda",
    landskap: "Småland",
    county: "Jönköpings län",
    tags: ["kött", "gårdsbutik"],
    description_short: "Naturbeteskött och hemgjorda korvar sedan tre generationer.",
    website: "https://smalandskotteri.se",
    instagram: "smalandskotteri",
    verified_at: "2026-01-20",
    lat: 57.4288,
    lng: 15.0786,
  },
];

export const ALL_TAGS = [
  "kött",
  "ägg",
  "mejeri",
  "grönt",
  "självplock",
  "café",
  "honung",
  "fisk",
  "gårdsbutik",
] as const;

export const REGIONS = [
  "Dalarna",
  "Skåne",
  "Öland",
  "Gotland",
  "Värmland",
  "Jämtland",
  "Halland",
  "Uppland",
  "Småland",
  "Bohuslän",
] as const;
